import { useContext } from 'react'
import { SidebarContext } from '../contexts'

export function useSidebar() {
  const context = useContext(SidebarContext)
  return context
}
